// components/views/ProfileView.jsx
import { useState, useEffect } from 'react';
import { Field, Callout, SectionLabel } from '../UI';

export default function ProfileView({ profile, onSave }) {
  const [p, setP] = useState({ ...profile });

  // Re-sync when profile loads from Supabase (boot is async)
  useEffect(() => {
    if (profile && Object.keys(profile).some(k => profile[k])) {
      setP({ ...profile });
    }
  }, [profile]);

  function upd(k, v) { setP(prev => ({ ...prev, [k]: v })); }

  return (
    <div>
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title">User Profile</h1>
          <p className="page-subtitle">Your information auto-fills STD 215 fields on all new contracts</p>
        </div>
        <button className="btn btn-gold" onClick={() => onSave(p)}>Save Profile</button>
      </div>

      <div className="card">
        <h3 className="card-title">Your Information</h3>
        <div className="form-grid">
          <Field label="Full Name" value={p.contactName} onChange={v => upd('contactName', v)} required />
          <Field label="Title / Classification" value={p.contactTitle} onChange={v => upd('contactTitle', v)} placeholder="e.g., Contract Specialist, Supervisor I" />
          <Field label="Phone" value={p.contactPhone} onChange={v => upd('contactPhone', v)} />
          <Field label="Email" value={p.contactEmail} onChange={v => upd('contactEmail', v)} />
        </div>

        <SectionLabel>Agency</SectionLabel>
        <div className="form-grid">
          <Field label="Agency Name" value={p.agencyName} onChange={v => upd('agencyName', v)} placeholder="Office of Energy Infrastructure Safety" />
          <Field label="Division / Unit" value={p.agencyDivision} onChange={v => upd('agencyDivision', v)} placeholder="Admin Services Division" />
          <Field label="SCO Agency Code" value={p.scoAgencyCode || ''} onChange={v => upd('scoAgencyCode', v)} monospace placeholder="e.g. 3355" hint="Used to auto-generate SCO IDs on contracts" />
          <Field label="Agency Billing Code" value={p.agencyBillingCode} onChange={v => upd('agencyBillingCode', v)} monospace placeholder="6-digit ABMS code" />
        </div>

        <SectionLabel>Accounting Officer</SectionLabel>
        <div className="form-grid">
          <Field label="Name" value={p.accountingOfficerName} onChange={v => upd('accountingOfficerName', v)} />
          <Field label="Title" value={p.accountingOfficerTitle} onChange={v => upd('accountingOfficerTitle', v)} />
          <Field label="Phone" value={p.accountingOfficerPhone} onChange={v => upd('accountingOfficerPhone', v)} />
          <Field label="Email" value={p.accountingOfficerEmail} onChange={v => upd('accountingOfficerEmail', v)} />
        </div>

        <SectionLabel>Authorized State Official (Signatory)</SectionLabel>
        <div className="form-grid">
          <Field label="Name" value={p.signatoryName} onChange={v => upd('signatoryName', v)} />
          <Field label="Title" value={p.signatoryTitle} onChange={v => upd('signatoryTitle', v)} />
          <Field label="Phone" value={p.signatoryPhone} onChange={v => upd('signatoryPhone', v)} />
          <Field label="Email" value={p.signatoryEmail} onChange={v => upd('signatoryEmail', v)} />
          <Field label="Street Address" value={p.signatoryAddress||''} onChange={v => upd('signatoryAddress', v)} className="span-full" />
          <Field label="City" value={p.signatoryCity||''} onChange={v => upd('signatoryCity', v)} />
          <Field label="Zip Code" value={p.signatoryZip||''} onChange={v => upd('signatoryZip', v)} />
        </div>

        <SectionLabel>Supervisor / SSM</SectionLabel>
        <div className="form-grid">
          <Field label="Supervisor Name" value={p.supervisorName} onChange={v => upd('supervisorName', v)} placeholder="e.g., Jay Naidu" />
          <Field label="Supervisor Title" value={p.supervisorTitle} onChange={v => upd('supervisorTitle', v)} placeholder="e.g., SSM II" />
          <Field label="Supervisor Phone" value={p.supervisorPhone} onChange={v => upd('supervisorPhone', v)} />
          <Field label="Supervisor Email" value={p.supervisorEmail} onChange={v => upd('supervisorEmail', v)} placeholder="supervisor@energysafety.ca.gov" />
        </div>

        <SectionLabel>Union Notification Contacts</SectionLabel>
        <p style={{ fontSize: 12.5, color: 'var(--slate-500)', marginBottom: 12 }}>
          These contacts are automatically CC'd on every Union Award Notification (GC 19131) drafted by Penny. Add your agency HR department, Labor Relations office, or any other required internal recipients.
        </p>
        <div className="form-grid">
          <Field label="HR Contact Name" value={p.unionHrName} onChange={v => upd('unionHrName', v)} placeholder="e.g., Energy Safety HR Department" />
          <Field label="HR Contact Email" value={p.unionHrEmail} onChange={v => upd('unionHrEmail', v)} placeholder="hr@energysafety.ca.gov" />
          <Field label="Labor Relations Contact Name" value={p.unionLrName} onChange={v => upd('unionLrName', v)} placeholder="e.g., Labor Relations Officer" />
          <Field label="Labor Relations Contact Email" value={p.unionLrEmail} onChange={v => upd('unionLrEmail', v)} placeholder="lr@energysafety.ca.gov" />
          <Field label="Additional CC Emails" value={p.unionCcEmails} onChange={v => upd('unionCcEmails', v)} placeholder="Comma-separated emails — e.g., chief@energysafety.ca.gov, legal@energysafety.ca.gov" className="span-full" />
        </div>

        <div className="btn-row">
          <button className="btn btn-gold" onClick={() => onSave(p)}>Save Profile</button>
        </div>
      </div>
    </div>
  );
}
